module.exports = __webpack_public_path__ + "img/pic-paging-service-3.da530261.jpg";